import {action, observable} from "mobx";

import apiUrl from "@const/apiUrl";
import baseState from "../../baseState";

// 菜单管理
export default class menuState extends baseState {
  // 列表
  @observable list = {};
  @action
  setList(data) {
    this.list = {records: data};
  }
  getList = (data) => {
    return this.fetch({
      url: apiUrl.PERMISSION.MENU.LIST,
      setState: this.setList,
      method: 'get',
      data
    });
  };
  // 详情
  @observable detail = {};
  @action
  setDetail(data) {
    this.detail = data;
  }
  getDetail = (id) => {
    return this.fetch({
      url: apiUrl.PERMISSION.MENU.DETAIL + id,
      setState: this.setDetail,
      method: 'get',
    });
  };

  insert = data => {
    return this.fetch({
      url: apiUrl.PERMISSION.MENU.INSERT,
      data,
    });
  };

  update = data => {
    return this.fetch({
      url: apiUrl.PERMISSION.MENU.UPDATE,
      data,
    });
  };

  delete = (id) => {
    return this.fetch({
      url: apiUrl.PERMISSION.MENU.DELETE + id,
    });
  };

  // // 模块管理下拉
  // @observable moduleList = [];
  // @action
  // setModuleList(data) {
  //   this.moduleList = data || [];
  // }
  // getModuleList = () => {
  //   return this.fetch({
  //     url: apiUrl.PERMISSION.MENU.MODULE_LIST,
  //     method: 'get',
  //     setState: this.setModuleList,
  //   });
  // };

}
